import mutationTypes from '../mutation-type'
export const cacheSelectedItems = store => {
  store.subscribe((mutation, state) => {
    switch (mutation.type) {
      case mutationTypes.ADD_SELECTED_ITEM:
      case mutationTypes.REMOVE_SELECTED_ITEM:
      case mutationTypes.INIT_ITEM_SORT:
      case mutationTypes.RECOVER_SELECTED_ITEMS:
      case mutationTypes.SET_ITEM_SORT:
      case mutationTypes.SYNC_ITEM_SCORE:
        sessionStorage.setItem('kw_si', JSON.stringify(state.paper.selectedItems))
        break
      case mutationTypes.CLEAR_SELECTED_ITEM:
        sessionStorage.removeItem('kw_si')
        break
    }
  })
}



// WEBPACK FOOTER //
// ./src/store/plugins/paper.js